/* global axios */
import ApiClient from '../ApiClient';

// Registro de auditoria da configuração: quem mudou o quê. Somente leitura, só admin.
class AuditoriaAPI extends ApiClient {
  constructor() {
    super('fandata/auditoria', { accountScoped: true });
  }

  listar({ acao, page } = {}) {
    return axios.get(this.url, { params: { acao, page } });
  }
}

export default new AuditoriaAPI();
